exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.sk-fade-in{animation:sk-fade-in 2s}.sk-fade-in-half-second{animation:sk-fade-in 1s}.sk-fade-in-quarter-second{animation:sk-fade-in .5s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-spinkit/css/fade-in.css
// module id = 839
// module chunks = 0